export default __webpack_public_path__ + "static/media/weather.90ab2c61.png";